import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "15px",
        lineHeight: "26px",
        weight: 400,
        fontFamily: "'Roboto', sans-serif",
    },
    p: {
        size: "15px",
        lineHeight: "26px",
        weight: 400,
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h1: {
        size: "28px",
        lineHeight: "33px",
        weight: 700,
        color: "common.ui12",
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h2: {
        size: "24px",
        lineHeight: "28px",
        weight: 700,
        color: "common.ui12",
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h3: {
        size: "20px",
        lineHeight: "24px",
        weight: 700,
        color: "common.ui12",
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h4: {
        size: "18px",
        lineHeight: "21px",
        weight: 700,
        color: "common.ui12",
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h5: {
        size: "16px",
        lineHeight: "19px",
        weight: 700,
        color: "secondary",
        css: css`
            margin-bottom: 1rem;
            display: block;
        `,
    },
    h6: {
        size: "10px",
        lineHeight: "11px",
        weight: 700,
        color: "secondary",
        css: css`
            margin-bottom: 1rem;
            display: block;
            letter-spacing: 1px;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "15px",
        transform: "uppercase",
        weight: 700,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "15px",
        color: "text.main",
        transform: "uppercase",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.main",
        transform: "uppercase",
        weight: 700,
    },
} as xBaseTheme["typography"];
